// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1347":"391ef5b2","1560":"c9418389","4880":"b2dd7353"}[chunkId] + ".chunk.css";
};